import infoStyle from "./info.module.css"
import managerStyle from "manager/manager.module.css"

import { useOffcanvas } from "offcanvas/provider"


export default function StatusInfo(props) {

    const { offcanvas_close } = useOffcanvas()

    const gradeList = window.EventManager.gradeList

    const event_name = props['']
    const student_name = props['studentName']
    const parent_phone = props['parentPhone']
    const student_grade = props['studentGrade']
    const response_list = props['UserResponses']

    return(
        <div className={infoStyle['infoWrap']}>

            <div
                style={{
                    width: "100%",
                    height: "calc(100% - 30px)",
                    overflowX: "hidden",
                    overflowY: "auto"
                }}
            >
                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>이름</label>
                    <div className={infoStyle['value']}>{student_name}</div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>연락처</label>
                    <div className={infoStyle['value']}>{parent_phone}</div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>학년</label>
                    <div className={infoStyle['value']}>
                        {function() {
                            const grade = gradeList.find(x => x['Mcode'].trim() === student_grade)
                            if(grade) {
                                return grade['McodeName']
                            }
                            else {
                                return ''
                            }
                        }()}
                    </div>
                </div>

                {response_list
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={infoStyle['block']}
                        >
                            <label className={infoStyle['label']}>{value['label']}</label>
                            <div className={infoStyle['value']}>{value['value']}</div>
                        </div>
                    )
                })}
            </div>

            <button
                type="button"
                className={`
                    ${managerStyle['button']}
                    ${managerStyle['secondary']}
                `}
                style={{
                    position: "absolute",
                    bottom: "0px",
                    width: "100%",
                    height: "30px"
                }}
                onClick={offcanvas_close}
            >닫기</button>
        </div>
    )
}